export const APP_CONFIG = {
  toasterLife: 4000,
  dataTable: {
    rowsPerPageOptions: [10, 25, 50],
    rows: 10
  }
}
